export const getUserNotificationState = state => state.userNotificationState;

export const getLoading = state => state.userNotificationState?.loading;

export const getUserNotifications = state =>
  state.userNotificationState?.notifications;
